import React from 'react';
import '../../css/vers2/MoreVisionSection.css';

type MoreVisionSectionProps = {
    setPage: React.Dispatch<React.SetStateAction<string>>;
};

const MoreVisionSection = ({ setPage }: MoreVisionSectionProps) => {
    return (
        <section id="visie" className="mv-scene">
            <img className="mv-title-img" src="/icons/more_vision/title.png" alt="Wat meer over mij" />

            <img className="mv-girl-img" src="/icons/more_vision/girl.png" alt="" />

            <div className="mv-text-left">
                <p>
                    Nadat ik met veel plezier tien jaar in de kinderopvang heb gewerkt, heb ik gekozen om
                    door te gaan als gastouder. Nu werk ik al zeven jaar als gastouder, het werken met
                    kinderen doe ik met plezier en graag ondersteun ik de kinderen in hun ontwikkeling.
                </p>

                <p className="mv-list-intro">Wat ik belangrijk vind tijdens de opvang:</p>

                <ol className="mv-list">
                    <li>Een gezellige huiselijke sfeer, waar de kinderen zich veilig en thuis kunnen voelen.</li>
                    <li>Dat ouders kunnen zien en voelen dat de opvang veilig is voor hun kinderen.</li>
                    <li>Ik heb een christelijke geloofsovertuiging, alle kinderen zijn welkom bij mij.</li>
                    <li>Actief bezig zijn met de kinderen.</li>
                    <li>Dagritme en structuur.</li>
                </ol>
            </div>

            <div className="mv-card mv-card-hours">
                <h3>Openingstijden (Mogelijk af te wijken)</h3>

                <p>
                    Maandag – <span className="mv-num">07:00 – 18:00</span><br />
                    Dinsdag – <span className="mv-num">07:00 – 18:00</span><br />
                    Woensdag – Gesloten<br />
                    Donderdag – <span className="mv-num">07:00 – 18:00</span><br />
                    Vrijdag – <span className="mv-num">07:00 – 18:00</span><br />
                    Zaterdag &amp; Zondag – Gesloten<br />
                    Nationale feestdagen – Gesloten
                </p>

                <p>Vakanties &amp; vrije dagen worden ruim van te voren doorgegeven aan de vraagouder.</p>
            </div>

            <div className="mv-card mv-card-vision">
                <h3>Mijn Visie</h3>

                <p>
                    Gezondheid en ontwikkeling. Ieder kind is uniek en heeft zijn of haar kwaliteiten.
                    Daarom vind ik het belangrijk dat elk kind serieus genomen wordt en dat er geluisterd
                    wordt naar de kinderen.
                </p>

                <p>
                    Elk kind heeft zijn of haar eigen behoeftes, voor de aller jongste kinderen is
                    veiligheid en geborgenheid erg belangrijk. De dreumesen en peuters kunnen al wat meer
                    vrijheid aan, zij hebben meer behoefte aan uitdaging en willen alles graag zelf ontdekken.
                </p>

                <p>
                    Als gastouder bied ik daarom diverse activiteiten aan die aansluiten bij de behoeftes
                    van de kinderen. Ook werk ik met thema&apos;s bijvoorbeeld: zomer, herfst, winter,
                    voertuigen enzv...
                </p>

                <p>
                    Daarnaast is buiten spelen ook wat ik belangrijk vind, is het niet in de tuin dan gaan
                    we gezellig naar een speeltuin in de buurt.
                </p>
            </div>
        </section>
    );
};

export default MoreVisionSection;
